import { useTranslation } from 'react-i18next';

/** Plain UI copy only: names, documents and user text never pass through this. */
export function SettingsText({
  i18nKey,
  defaults,
}: {
  i18nKey: string;
  defaults: string;
  ns?: string;
}) {
  const { t } = useTranslation('settings');
  const translated = t(i18nKey, defaults);
  return <>{translated === i18nKey ? defaults : translated}</>;
}
